import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { ProgramRole } from '../../enums';
import { ProgramType } from '../../enums/program-type.enum';
import { IdName } from '../../models/id-name.model';

@Pipe({
  name: 'programRole',
  standalone: false
})
export class ProgramRolePipe implements PipeTransform {
  public transform(value: ProgramRole, programType: ProgramType): string {
    return getProgramRole(value, programType);
  }
}

export function getProgramRole(value: ProgramRole, programType: ProgramType): string {
  switch (value) {
    case ProgramRole.Coordinator:
      return 'Coordinator';
    case ProgramRole.Supervisor:
      return 'Supervisor';
    case ProgramRole.Trainer:
      return programType === ProgramType.FieldTraining ? 'Trainer' : 'Mentor';
    case ProgramRole.Trainee:
      return programType === ProgramType.FieldTraining
        ? 'Trainee'
        : programType === ProgramType.Mentoring
        ? 'Mentee'
        : 'Employee';
    default:
      throw new Error(`Unsupported value for ProgramRole: ${value}.`);
  }
}

export function getProgramRoleList(programType: ProgramType): Array<IdName> {
  return enumToList(ProgramRole, (value) => getProgramRole(value, programType));
}

export function getFtProgramRoleList(): Array<IdName> {
  return getProgramRoleList(ProgramType.FieldTraining);
}

export function getPeProgramRoleList(): Array<IdName> {
  return getProgramRoleList(ProgramType.PerformanceEvaluation).filter((x) => x.id !== ProgramRole.Trainer);
}

export function getMtProgramRoleList(): Array<IdName> {
  return getProgramRoleList(ProgramType.Mentoring).filter((x) => x.id !== ProgramRole.Supervisor);
}
